import { render, staticRenderFns } from "./VerifiedUserIcon.vue?vue&type=template&id=d9e5decc"
import script from "./VerifiedUserIcon.vue?vue&type=script&lang=js"
export * from "./VerifiedUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports